import { onTurboPageLoad } from "../turboHelper";
import { attachSummernote } from "../summernoteHelper";
import { getModel } from "../modelHelper";
import { formSubmitWithWaitForJobCompletion } from "../jobCompletion";
import * as Turbo from "@hotwired/turbo";
import { attachCancelButtonConfirmation, parseJson, setJsonValue } from "../helpers";
import * as L from "leaflet";
import { initializeMap, addPoiToMap, allowDrawingOnePolyline, addTriggerZonesToMap, PolylineInfo, updatePolyline } from "../leafletHelper";
import { ITriggerZone, GpsCoordinates } from "../sharedModels";
import * as GeometryUtil from "leaflet-geometryutil";
import { getScoreFunctionPreservingOrderInSearch, selectize } from "../selectizeHelper";
import { IGpsCoordinates } from "../_generated/IGpsCoordinates";
import { IBoundingBox } from "../_generated/IBoundingBox";
import { TourType } from "../_generated/TourType";

onTurboPageLoad("Tours/Edit", () => {
    const model = getModel<ITourEditModel>();

    const form = $("#editTourForm");
    const editorInputs = $(".html-editor");
    attachSummernote(editorInputs);

    formSubmitWithWaitForJobCompletion(
        form,
        $("#submit"),
        model.getJobUrl,
        () => {
            Turbo.clearCache();
            history.back();
        },
        undefined,
        model.shouldEnableDataValidationInputName
    );

    const routeWaypointsHiddenInput = $(`#${model.routeWaypointsHiddenInputId}`);
    const autoGenerateRouteButton = $("#autoGenerateRoute");

    var routePolylineInfo: PolylineInfo;
    var map: L.Map;
    setupMap();

    autoGenerateRouteButton.on("click", () => {

        var url = autoGenerateRouteButton.data("generate-route-for-tour-url");
        $.getJSON(url,
                (autoGeneratedRouteWaypoints: GpsCoordinates[]) => {
                    updatePolyline(map, "#89BAED", autoGeneratedRouteWaypoints, routePolylineInfo);
                    setJsonValue(routeWaypointsHiddenInput, autoGeneratedRouteWaypoints);
                    recalculateTourLengthAndDuration(autoGeneratedRouteWaypoints);
                })
            .fail((jqXhr, textStatus, errorThrown) => {
                bootbox.alert({
                    title: "Error generating route for the tour",
                    message: `HTTP status code: ${jqXhr.status} ${errorThrown}`,
                    size: "large"
                });
            });
    });

    const tourTypeSelect = $(`#${model.tourTypeSelectId}`);

    selectize(tourTypeSelect, {
        score: getScoreFunctionPreservingOrderInSearch
    });

    attachCancelButtonConfirmation();

    function setupMap() {
        const northWestLatitude = model.boundingBox.northWest.latitude;
        const northWestLongitude = model.boundingBox.northWest.longitude;
        const southEastLatitude = model.boundingBox.southEast.latitude;
        const southEastLongitude = model.boundingBox.southEast.longitude;

        map = initializeMap([new L.LatLng(northWestLatitude, northWestLongitude), new L.LatLng(southEastLatitude, southEastLongitude)]);

        var routeWaypoints = parseJson<GpsCoordinates[]>(routeWaypointsHiddenInput.val());

        $.each(model.pois, (index, poi) => {
            addPoiToMap(map, [poi.coordinates.latitude, poi.coordinates.longitude], poi.mainImageUrl, poi.name);
            addTriggerZonesToMap(map, poi.triggerZones, poi.name);
        });

        routePolylineInfo = allowDrawingOnePolyline(
            map,
            "#3388ff",
            routeWaypoints,
            routeWaypointsToSet => {
                setJsonValue(routeWaypointsHiddenInput, routeWaypointsToSet);
                recalculateTourLengthAndDuration(routeWaypointsToSet);
            },
            [
                [".leaflet-draw-draw-polyline", "Draw a tour route"],
                [".leaflet-draw-edit-edit", "Edit a tour route"],
                [".leaflet-draw-edit-remove", "Delete a tour route"],
                [".leaflet-draw-edit-edit.leaflet-disabled", "No tour route to edit"],
                [".leaflet-draw-edit-remove.leaflet-disabled", "No tour route to delete"]
            ]
        );
    }

    const lengthInMetresInput = $(`#${model.lengthInMetresInputId}`);
    const durationInMinutesInput = $(`#${model.durationInMinutesInputId}`);
    const recalculateTourLengthCheckbox = $("#recalculateTourLengthCheckbox");
    const recalculateTourDurationCheckbox = $("#recalculateTourDurationCheckbox");

    var lengthInMetres = Number(lengthInMetresInput.val());
    var durationInMinutes = Number(durationInMinutesInput.val());

    function recalculateTourLengthAndDuration(routeWaypoints: GpsCoordinates[]) {
        lengthInMetres = GeometryUtil.length(routeWaypoints.map(x => new L.LatLng(x.latitude, x.longitude)));
        const speed = model.defaultWalkingSpeedInMetersPerSecond; // todo: handle other tour types at some point, using different speed.
        durationInMinutes = lengthInMetres / speed / 60;

        if (recalculateTourLengthCheckbox.is(":checked")) {
            lengthInMetresInput.val(Math.round(lengthInMetres));
        }

        if (recalculateTourDurationCheckbox.is(":checked")) {
            durationInMinutesInput.val(Math.round(durationInMinutes));
        }
    }
});

interface ITourEditPoiViewModel {
    coordinates: IGpsCoordinates;
    mainImageUrl: string;
    name: string;
    triggerZones: ITriggerZone[];
}

interface ITourEditModel {
    boundingBox: IBoundingBox;
    routeWaypointsHiddenInputId: string;
    tourTypeSelectId: string;
    getJobUrl: string;
    pois: ITourEditPoiViewModel[];
    shouldEnableDataValidationInputName: string;
    durationInMinutesInputId: string;
    lengthInMetresInputId: string;
    defaultWalkingSpeedInMetersPerSecond: number;
}
